export default __webpack_public_path__ + "static/media/birthday_card.f53d1148.png";